import styled from 'styled-components';

interface StyledStatisticWrapperProps {
  $isBackground?: boolean;
  $paddingLeft? : boolean;
}
interface StyledColorWrapperRedProps {
  $isOrangeBackground?: boolean;
  $isPlayer? : boolean;
}
interface StyledColorWrapperRedSmallProps {
  $isOrangeBackground?: boolean;
}
interface StyledCalendarWrapperProps {
  $noBorder?: boolean;
  $isSmall? : boolean;
}

const StyledColorWrapper = styled.div`
  border-right: 1px solid ${(props) => props.theme.colors.secondaryBg};
  > div {
    padding: 0 2.28rem;
  }
  min-width: 15rem;
  flex-grow: 1;
  position: relative;
  top: 1px;
  font-size: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  span {
    &:first-child {
      color: ${(props) => props.theme.colors.primaryText};
      justify-content: flex-start;
      margin-bottom: 0.28rem;
      > div:first-child {
        max-width: 11rem;
      }
    }
    &:last-child {
      justify-content: flex-start !important;
      margin-bottom: 0;
      color: ${(props) => props.theme.colors.primaryText};
    }
  }
`;

const StyledColorWrapperSmall = styled(StyledColorWrapper)`
  border-right: none;
  padding: 0.7rem 1.71rem;
  height: 2.7rem;
  margin-bottom: 1px;
  width: 22.5rem;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    width: 100%;
  }
  span {
    &:first-child {
      color: ${(props) => props.theme.colors.primaryText};
      display: flex;
      justify-content: flex-start;
      margin-bottom: 0;
    }
  }
`;

const StyledStatisticWrapper = styled.div<StyledStatisticWrapperProps>`
  display: flex;
  align-items: center;
  height: 4.6rem;
  background: ${(props) => (!props.$isBackground ? `${props.theme.colors.primaryBorder}10` : props.theme.colors.secondaryBg)};
  padding: 0;
  padding-left: ${(props) => props.$paddingLeft && '1.14rem'};
  border-radius: 0;
  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  }
`;

const StyledStatisticWrapperSmall = styled(StyledStatisticWrapper)`
  flex-direction: column;
  height: 100%;
  align-items: center;
  padding: 0.35rem 0;
  border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
`;
const StyledCalendarWrapper = styled.div<StyledCalendarWrapperProps>`
  display: flex;
  align-items: center;
  > div {
    &:first-child {
      padding: 0 1.14rem;
    }
    display: flex;
    align-items: center;
  }
  font-size: 1rem;
  height: ${(props) => (props.$isSmall ? '100%' : ' 3rem')};
`;
const StyledPeriodWrapper = styled.div`
  strong {
    color: ${(props) => props.theme.colors.primaryText};
    &:first-child {
      justify-content: flex-start;
      margin-right: 1.14rem;
    }
  }
`;
const StyledCurrencyWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1.71rem;
  font-size: 1rem;
  > div {
    &:first-child {
      margin-right: 1.14rem;
    }
  }
`;
const StyledCurrencyRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${(props) => props.theme.colors.secondaryColor};
  &:first-child {
    margin-bottom: 8px;
  }
`;
const StyledCurrencyTextWrapper = styled.span`
  margin-bottom: 0.57rem !important;
`;
const StyledPeriodsIcons = styled.div`
  margin-left: auto;
  padding-right: 1.71rem;
  display: flex;
`;
const StyledColorWrapperPurple = styled(StyledColorWrapper)`
  background: #eb2f9630;
  border-bottom: 2px solid #eb2f96;
`;
const StyledColorWrapperPurpleSmall = styled(StyledColorWrapperSmall)`
  background: #eb2f9630;
  border-left: 2px solid #eb2f96;
`;
const StyledColorWrapperBlueBorder = styled(StyledColorWrapper)`
  background: #1890ff30;
  border-bottom: 2px solid #1890ff;
`;
const StyledColorWrapperBlueBorderSmall = styled(StyledColorWrapperSmall)`
  background: #1890ff30;
  border-left: 2px solid #1890ff;
`;
const StyledColorWrapperGreen = styled(StyledColorWrapper)`
  background: #52c41a30;
  border-bottom: 2px solid #52c41a;
`;
const StyledColorWrapperGreenSmall = styled(StyledColorWrapperSmall)`
  background: #52c41a30;
  border-left: 2px solid #52c41a;
`;
const StyledColorWrapperOrange = styled(StyledColorWrapper)`
  background: #fa8c1630;
  border-bottom: 2px solid #fa8c16;
`;
const StyledColorWrapperOrangeSmall = styled(StyledColorWrapperSmall)`
  background: #fa8c1630;
  border-left: 2px solid #fa8c16;
`;
const StyledColorWrapperGreySmall = styled(StyledColorWrapperSmall)`
  background: #bfbfbf30;
  border-left: 2px solid #bfbfbf;
`;
const StyledViewWrapper = styled.div`
  cursor: pointer;
`;
const StyledColorWrapperGrey = styled(StyledColorWrapper)`
  background: #bfbfbf30;
  border-bottom: 2px solid #bfbfbf;
  width: 8rem;
  min-width: unset;
  span {
    display: block;
  }
`;
const StyledColorWrapperRed = styled(StyledColorWrapper)<StyledColorWrapperRedProps>`
  background: ${(props) => (props.$isOrangeBackground ? '#faad1430' : '#fa791c30')};
  border-bottom: ${(props) => (props.$isOrangeBackground ? '2px solid #faad14' : '2px solid #fa791c')};
  width: ${(props) => (props.$isPlayer ? '23rem' : '18rem')};
  div {
    width: 100%;
    max-width: 100% !important;
  }
`;
const StyledColorCashbackWrapperRed = styled(StyledColorWrapperRed)`
  width: 16rem;
`;
const StyledColorWrapperRedSmall = styled(StyledColorWrapperSmall)<StyledColorWrapperRedSmallProps>`
  background: ${(props) => (props.$isOrangeBackground ? '#e20a1630' : '#FADB1430')};
  border-left: ${(props) => (props.$isOrangeBackground ? '2px solid #e20a16' : '2px solid #FADB14')};
  width: 100%;
`;
const StyledColorWrapperBlue = styled(StyledColorWrapper)`
  background: #13c2c230;
  border-bottom: 2px solid #13c2c2;
`;
const StyledColorWrapperBlueSmall = styled(StyledColorWrapperSmall)`
  background: #13c2c230;
  border-left: 2px solid #13c2c2;
`;

const StyledEmptyList = styled.div`
  background: ${(props) => props.theme.colors.primaryBg};
  border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  border-radius: ${(props) => `${props.theme.customBorderRadius.borderRadiusSmall} ${props.theme.customBorderRadius.borderRadiusSmall} 0 0`};
  .ant-empty-normal {
    padding: 2.9rem 0;
    margin: 0;
  }
`;

const StyledExpandedListWrapper = styled.div`
    .ant-table-expanded-row-cell {
        background-color: ${(props) => props.theme.colors.primaryBg};
    }
`;

const StyledExpandedListBlock = styled.div`
  border: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
  overflow: auto;
  max-height: 16rem;

  .ant-list-items li {
    padding: 0;
    height: 4rem;
    border-bottom: 1px solid  ${(props) => props.theme.colors.secondaryBorder};
    ${StyledStatisticWrapper} {
      height: 3.9rem;
      ${StyledPeriodsIcons} {
        width: 43%;
        & > div {
          width: 100%;
        }
      }
    }
  }
`;

export {
  StyledStatisticWrapper,
  StyledCalendarWrapper,
  StyledPeriodWrapper,
  StyledCurrencyTextWrapper,
  StyledColorWrapper,
  StyledColorWrapperPurple,
  StyledColorWrapperGreen,
  StyledColorWrapperOrange,
  StyledColorWrapperGrey,
  StyledColorWrapperRed,
  StyledColorCashbackWrapperRed,
  StyledColorWrapperBlue,
  StyledCurrencyWrapper,
  StyledCurrencyRightWrapper,
  StyledColorWrapperBlueBorder,
  StyledPeriodsIcons,
  StyledStatisticWrapperSmall,
  StyledColorWrapperOrangeSmall,
  StyledColorWrapperGreenSmall,
  StyledColorWrapperPurpleSmall,
  StyledColorWrapperSmall,
  StyledColorWrapperBlueBorderSmall,
  StyledColorWrapperBlueSmall,
  StyledColorWrapperRedSmall,
  StyledColorWrapperGreySmall,
  StyledViewWrapper,
  StyledEmptyList,
  StyledExpandedListWrapper,
  StyledExpandedListBlock,
};
